<div class="kql-queries-container">
  <div class="back-to-logs-link">
    <a href="#logs" class="btn btn-outline-primary" data-toggle="tab">
      ← BACK TO LOGS PAGE
    </a>
  </div>
  <div class="header-actions">
    <h3>KQL Query Examples</h3>
    <button type="button" class="btn btn-primary" (click)="openAddModal()">
      Add New Query
    </button>
  </div>

  <div *ngIf="isLoading" class="text-center mt-3">
    <em>Loading...</em>
  </div>

  <div *ngIf="!isLoading && queries.length === 0" class="mt-3">
    <em>No queries found. Click "Add New Query" to create one.</em>
  </div>

  <div *ngIf="!isLoading && queries.length > 0" class="table-responsive mt-3">
    <table class="table table-striped table-sm">
      <thead>
        <tr>
          <th>Description</th>
          <th>Query</th>
          <th>Last Updated</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let query of queries">
          <td>{{ query.description }}</td>
          <td class="query-column">
            <code>{{ query.query }}</code>
            <button
              type="button"
              class="btn btn-sm btn-link p-0 ml-2"
              (click)="copyQueryToClipboard(query.query)"
              title="Copy to clipboard"
            >
              📋
            </button>
          </td>
          <td>{{ formatDate(query.dateLastModifiedUtc) }}</td>
          <td>
            <button
              type="button"
              class="btn btn-sm btn-primary mr-1"
              (click)="openEditModal(query)"
            >
              Edit
            </button>
            <button
              type="button"
              class="btn btn-sm btn-danger"
              (click)="deleteQuery(query)"
            >
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Edit Modal -->
  <div
    *ngIf="showEditModal"
    class="modal"
    style="display: block"
    tabindex="-1"
    role="dialog"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ editingQuery ? "Edit Query" : "Add New Query" }}
          </h5>
          <button
            type="button"
            class="close"
            (click)="closeEditModal()"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form [formGroup]="editForm">
            <div class="form-group">
              <label for="description">Description</label>
              <input
                type="text"
                id="description"
                class="form-control"
                formControlName="description"
                [class.is-invalid]="
                  editForm.get('description')?.invalid &&
                  editForm.get('description')?.touched
                "
              />
              <div
                class="invalid-feedback"
                *ngIf="
                  editForm.get('description')?.invalid &&
                  editForm.get('description')?.touched
                "
              >
                Description is required (max 500 characters).
              </div>
            </div>

            <div class="form-group">
              <label for="query">KQL Query</label>
              <textarea
                id="query"
                class="form-control"
                formControlName="query"
                rows="6"
                [class.is-invalid]="
                  editForm.get('query')?.invalid &&
                  editForm.get('query')?.touched
                "
              ></textarea>
              <div
                class="invalid-feedback"
                *ngIf="
                  editForm.get('query')?.invalid &&
                  editForm.get('query')?.touched
                "
              >
                Query is required.
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            (click)="closeEditModal()"
          >
            Cancel
          </button>
          <button
            type="button"
            class="btn btn-primary"
            (click)="saveQuery()"
            [disabled]="editForm.invalid"
          >
            {{ editingQuery ? "Update" : "Create" }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="showEditModal" class="modal-backdrop fade show"></div>
</div>

